import {TimelineSprite} from "@nolimitcity/slot-launcher/bin/animation/TimelineSprite";
import {Oktoberfest} from "../Oktoberfest";
import {TimelineLite} from "gsap";
import {Layers, OktoberfestLayers} from "./OktoberfestLayers";
import {OktoberfestSymbolState} from "../symbol/OktoberfestSymbolConfig";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";

export class OktoberfestNudgeWildView extends PIXI.Container {

    private _W3_1_anim: TimelineSprite;
    private _offsetY: number = 107;

    constructor() {
        super();
        this.init();
        this.visible = false;
        OktoberfestLayers.getLayer(Layers.WILD_3_LAYER)!.addChild(this);
    }

    public startAnimation(): TimelineLite {
        this.visible = true;
        const tl: TimelineLite = new TimelineLite();
        this._W3_1_anim.hide();
        this._W3_1_anim.y = this._offsetY + Oktoberfest.reels[2].getSymbol(0).position.y;
        tl.add(this._W3_1_anim.getAnimationAutoShowHide(true, true, [0], () => {
        }, () => {

        }));
        tl.add(() => {
            Oktoberfest.reels[2].replaceSimpleSymbol(0, "W3");
        }, this._W3_1_anim.totalDuration/3);
        tl.add(() => {
            Oktoberfest.reels[2].getSymbol(0).getStateAnimation(OktoberfestSymbolState.LAND,
                {duration: 0.01, alpha: 1},
                {duration: 0.01, alpha: 0}
            );
        }, 1.5);
        tl.add(() => {
            Oktoberfest.reels[2].getSymbol(0).getStateAnimation(OktoberfestSymbolState.WIN,
                {duration: 0.01, alpha: 1},
                {duration: 0.01, alpha: 0}
            );
        }, 0.1);
        return tl;
    }

    public onResize(): void {
        if (NolimitApplication.isLandscape) {
            this._W3_1_anim.x = 360;
            this._W3_1_anim.y = 179;
            this._W3_1_anim.scale.set(1);
        } else {
            this._W3_1_anim.scale.set(0.9);
            this._W3_1_anim.x = 357;
            this._offsetY = 85;
        }
    }

    private init(): void {
        this._W3_1_anim = this.createAnimation("W3_att");
        this._W3_1_anim.hide();
        this.onResize();
    }

    private createAnimation(texture: string): TimelineSprite {
        const animation: TimelineSprite = new TimelineSprite(Oktoberfest.assetLoader.getTextures(texture));
        animation.anchor.set(0.5);
        this.addChild(animation);
        return animation;
    }
}
